<template>
  <div class="header">
    <el-menu theme="light" :router="true" class="el-menu-demo" mode="horizontal">
      <li class="el-submenu" style="width:80px;height:60px">
        <!-- <img class="wemedia-logo" src="../assets/top_influencers.png"> -->
      </li>
      <el-submenu
        v-for="(item, index) in routeList" :key="index" :index="`${index+1}`"
        v-if="permissions.includes(item.meta.authorize)"
      >
        <template slot="title">{{ item.name }}</template>
        <el-menu-item
          v-for="(children, i) in childrenMenu(item.children)" :key="i" :index="`${item.path}/${children.path}`"
          v-if="permissions.includes(children.meta.authorize)"
        >
          <!-- v-if="permissions.includes(children.meta.authorize)" -->
          {{ children.name }}
        </el-menu-item>
      </el-submenu>
      <!-- <el-submenu index="6">
        <template slot="title">Reward</template>
        <el-menu-item index="/reward/income" class="nav-link">Income</el-menu-item>
        <el-menu-item index="/buy/list" class="nav-link">BuyList</el-menu-item>
        <el-menu-item index="/reward/withdrawal" class="nav-link">Withdrawal</el-menu-item>
        <el-menu-item index="/reward/wallet" v-if="walletManager.includes(name)" class="nav-link">Wallet</el-menu-item>
      </el-submenu> -->
      <el-submenu class="user" index="0">
        <template slot="title">{{ name }}</template>
        <el-menu-item class="logout" @click="logout()" index="0-1">logout</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: 'headerNavigation',
  data () {
    return {
      name: '',
      walletManager: ['admin'],
      routeList: null,
      permissions: window.localStorage.getItem('user-permissions')
    }
  },
  methods: {
    logout () {
      console.log('system logout')
      localStorage.setItem('user-token', '') // 将token清空
      localStorage.setItem('user-name', '')
      localStorage.setItem('user-id', '')
      window.localStorage.setItem('token-expire', 'false')
      window.history.go(0) // 退出登录时，刷新页面。两个作用：1，解决过多组件回收卡顿（销毁vs回收）；2. 使 keep-alive 页面登录后重新加载数据(mount 钩子生效)
    },
    createNavigation () {
      this.routeList = this.$router.options.routes.filter(route => {
        if (route.name) return route
      })
    },
    childrenMenu (childrenMenu) {
      return childrenMenu.filter(route => {
        if (route.name) return route
      })
    }
  },
  mounted: function () {
    this.createNavigation()
    this.name = localStorage.getItem('user-name')
  }
}
</script>

<style scoped>
  .header {
    height: 80px;
    min-width: 1170px;
    margin: 0 auto;
  }

  .el-submenu {
    height: 80px !important;
    line-height: 80px !important;
    min-width: 0 !important;
  }

  .el-submenu >>> .el-submenu__title {
    height: 80px !important;
    line-height: 80px !important;
  }

  .el-menu-item {
    height: 80px !important;
    line-height: 80px !important;
    min-width: 0 !important;
  }

  .el-submenu.user {
    float: right !important;
    margin-right: 40px;
  }

  .logout {
    height: 40px !important;
    line-height: 40px !important;
  }

  .wemedia-logo {
    max-height: 80px;
    padding: 0 20px 0 40px;
    vertical-align: middle;
    overflow: hidden;
  }
  .subnav {
    height: 50px !important;
    line-height: 50px !important;
  }
  .subnav .el-submenu__title {
    height: 50px !important;
    line-height: 50px !important;
    border-bottom: 5px solid transparent !important;
  }
  .el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
  }
  .subnav .el-menu {
    top: 0 !important;
    left: 100px !important;
  }
  .el-menu--horizontal .el-submenu .el-menu-item {
    float: left;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?8b31bc6c